module.exports = __webpack_public_path__ + "img/5.a3ca0fd8.png";